<template>
   <div class="footer-bar">
     <div class="items flex-items flex-between">
         <div class="left">
           <div class="flex-items">
             <div class="flex-items imgs">
               <img src="../assets/images/nav/kf.png" alt="">
               <div>
                 <div class="title">客服热线</div>
                 <div class="sub-title">{{ baseInfo.custom_phone }}</div>
               </div>
             </div>
             <div class="flex-items">
               <img src="../assets/images/nav/email.png" alt="">
               <div>
                 <div class="title">电子邮箱</div>
                 <div class="sub-title">{{ baseInfo.business_email }}</div>
               </div>
             </div>
           </div>
           <div class="copy">
             <a href="https://beian.miit.gov.cn/" target="_blank"> {{baseInfo.beian}}</a>

           </div>
         </div>
         <div class="right qr">
           <img :src="baseInfo.mini_qr_code" alt="">
             <div>
               {{baseInfo.mini_name}}
             </div>
         </div>
     </div>

   </div>
</template>

<script>
export default {
  name: "FooterBar",
  data(){
    return{
      info:{}
    }
  },
  computed:{
    baseInfo(){
      return this.$store.state.baseInfo
    }
  },
  created(){
    //let that=this;
    // that.$get('/api/config',{}).then(r=>{
    //   this.info=r.data;
    //   document.title =r.data.web_name
    // })
  },
  mounted(){
    this.getConfig()
  },
  methods:{
    getConfig(){
      this.$post('/api/index/config', {type:''}).then(res => {
        this.setConfig(res.data)
      })
    },
  }
}
</script>

<style scoped lang="scss">
   .footer-bar{
     height:181px;
     background-color: #333333;
     color: #fff;
     .items{
       max-width:1200px;
       padding: 25px 0;
       cursor: pointer;
       margin: 0 auto;
       .left{
         .title{
           font-size: 16px;
           color: #FFFFFF;
           line-height: 28px;
         }
         .sub-title{
           font-weight: 400;
           font-size: 12px;
           color: #FFFFFF;
         }
         img{
           width: 40px;
           height: 40px;
           margin-right: 11px;
         }
         .imgs{
           margin-right: 50px;
         }
         .copy{
           font-weight: 400;
           font-size: 14px;
           color: #A8A8A8;
           line-height: 28px;
           margin-top: 36px;
           a{
             color: #A8A8A8;
             text-decoration: none;
           }
         }
       }
         .qr{
           display: flex;
           flex-direction: column;
           justify-content: center;
           align-items: center;
           img{
            width: 110px;
             height: 110px;
             border-radius: 50%;
           }
           div{
             margin-top: 5px;
             font-weight: 400;
             font-size: 14px;
             color: #FFFFFF;
             line-height: 28px;
           }
       }
     }


   }
</style>
